import { render, staticRenderFns } from "./WorkItems.vue?vue&type=template&id=4b95fb1e&scoped=true&"
import script from "./WorkItems.vue?vue&type=script&lang=js&"
export * from "./WorkItems.vue?vue&type=script&lang=js&"
import style0 from "./WorkItems.vue?vue&type=style&index=0&id=4b95fb1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95fb1e",
  null
  
)

export default component.exports